import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Bell, LogOut, Home, Plus } from "lucide-react";
import { Logo } from "@/components/marketing/Nav";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function AppShell({ children, title, back }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    api.get("/notifications").then((r) => setUnread(r.data.filter((n) => !n.read).length)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-softcream">
      <header className="sticky top-0 z-40 border-b border-hborder bg-white">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6">
          <Logo />
          <div className="flex items-center gap-1.5">
            <Link to="/app" className="grid h-10 w-10 place-items-center rounded-lg text-navy hover:bg-softcream" aria-label="Home" data-testid="app-home-btn"><Home size={19} /></Link>
            <Link to="/app/notifications" className="relative grid h-10 w-10 place-items-center rounded-lg text-navy hover:bg-softcream" aria-label="Notifications" data-testid="app-notifications-btn">
              <Bell size={19} />
              {unread > 0 && <span className="absolute right-1.5 top-1.5 grid h-4 min-w-4 place-items-center rounded bg-coral px-1 text-[10px] font-bold text-white" data-testid="notif-count">{unread}</span>}
            </Link>
            <button onClick={() => { logout(); navigate("/"); }} className="grid h-10 w-10 place-items-center rounded-lg text-navy hover:bg-softcream" aria-label="Sign out" data-testid="app-logout-btn"><LogOut size={19} /></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 md:py-8">
        {(title || back) && (
          <div className="mb-6 flex items-center justify-between gap-3">
            <div>
              {back && <Link to={back.to} className="mb-1 inline-block text-sm text-tblue hover:underline" data-testid="app-back-link">← {back.label}</Link>}
              {title && <h1 className="font-serif text-2xl tracking-tight text-heading md:text-3xl">{title}</h1>}
            </div>
          </div>
        )}
        {children}
      </main>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action }) {
  return (
    <div className="rounded-md border border-dashed border-hborder bg-white p-12 text-center" data-testid="empty-state">
      {Icon && <Icon className="mx-auto text-muted/50" size={40} />}
      <h3 className="mt-4 font-serif text-xl text-heading">{title}</h3>
      {body && <p className="mx-auto mt-2 max-w-sm text-sm text-muted">{body}</p>}
      {action}
    </div>
  );
}

export function NewCaseButton() {
  return (
    <Link to="/app/new" className="inline-flex items-center gap-2 rounded bg-brandyellow px-5 py-2.5 text-sm font-semibold text-heading" data-testid="new-case-btn">
      <Plus size={16} /> New case
    </Link>
  );
}
